import { Provider } from "react-redux";
import { useRoutes } from "react-router-dom";
// MUI DATE PICKER
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// ALL CONTEXT FILES
// import { AuthProvider } from "app/contexts/FirebaseAuthContext";
import { AuthProvider } from "app/contexts/JWTAuthContext";
import { SettingsProvider } from "app/contexts/SettingsContext";
// THEME PROVIDER
import { MatxTheme } from "./components/MatxTheme";
// REDUX STORE
import store from "./redux/store";
// ALL ROUTES
import routes from "./routes";
// session timeout provider
import useSessionTimeout from "app/hooks/useSessionTimeout";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";

export default function App() {
  const content = useRoutes(routes);

  const {
    showWarning,
    continueSession,
    logout,
    countdown
  } = useSessionTimeout();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Provider store={store}>
        <SettingsProvider>
          <MatxTheme>
            <AuthProvider>
              {content}
              <Dialog open={showWarning} maxWidth="xs" fullWidth>
                <DialogTitle>RLSS Session Expiring</DialogTitle>

                <DialogContent>
                  <Typography>
                    Your RLSS session is about to expire due to inactivity.
                  </Typography>

                  <Typography sx={{ mt: 2 }}>
                    You will be logged out in <strong>{countdown}</strong> seconds.
                  </Typography>
                </DialogContent>

                <DialogActions>
                  <Button color="error" onClick={logout}>
                    Logout
                  </Button>

                  <Button variant="contained" onClick={continueSession}>
                    Continue Session
                  </Button>
                </DialogActions>
              </Dialog>
            </AuthProvider>
          </MatxTheme>
        </SettingsProvider>
      </Provider>
    </LocalizationProvider>
  );
}
